<template>
  <div>
    <!-- 可发货订单 -->
    <baseBreadcrumb :page="$t('message.deliverableOrder')" :menu="$t('message.orderForm')" />
    <orderMain status="70" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped></style>